import { request } from "./request.js";

export async function get(key) {
    return await request("/appointment", { key: key }, "POST");
}

export async function save(data) {
    return await request("/appointment/save", data, "POST");
}

export async function schedule(data) {
    return await request("/appointment/schedule", data, "POST");
}

export async function defaults() {
    return await request("/appointment/defaults", {}, "POST");
}

export async function uncleared() {
    return await request("/appointment/uncleared", {}, "POST");
}
